import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import API from "../api/api";
import { gradeClassFor } from "../utils/honeyGrade";
import { localizedName, localizedDescription } from "../utils/localizeProduct";
import { useLanguage } from "../i18n/LanguageContext";

function ProductDetails({ onAddToOrder }) {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [notFound, setNotFound] = useState(false);
  const { language, t } = useLanguage();

  useEffect(() => {
    API.get(`/api/products/${id}`)
      .then((res) => setProduct(res.data))
      .catch((err) => {
        console.error("Error loading product", err);
        setNotFound(true);
      });
  }, [id]);

  if (notFound) return <p style={{ textAlign: "center" }}>{t("product.notFound")}</p>;
  if (!product) return <p style={{ textAlign: "center" }}>{t("product.loading")}</p>;

  const name = localizedName(product, language);
  const description = localizedDescription(product, language);

  return (
    <div className="pd-layout">
      <div>
        {product.imageUrl ? (
          <img src={product.imageUrl} alt={name} style={{ width: "100%", borderRadius: "12px" }} />
        ) : (
          <div className="jar-swatch lg">
            <div className="jar-lid" />
            <div className="jar-neck" />
            <div className={`jar-body ${gradeClassFor(product)}`} />
          </div>
        )}
      </div>

      <div>
        <div className="pd-crumb">
          <Link to="/products">{t("product.breadcrumbShop")}</Link> / {name}
        </div>
        <h1>{name}</h1>
        <div className="pd-lot">{t("product.rawUnfiltered")}</div>
        <div className="pd-price">${Number(product.price).toFixed(2)}</div>
        {description && <p className="pd-note">{description}</p>}

        <div className="pd-actions">
          <label htmlFor="qty" style={{ fontSize: "0.85rem", color: "var(--ink-soft)" }}>
            {t("product.qty")}
          </label>
          <input
            id="qty"
            className="pd-qty-input"
            type="number"
            min="1"
            value={quantity}
            onChange={(e) => setQuantity(Math.max(1, Number(e.target.value)))}
          />
          <button className="btn" onClick={() => onAddToOrder(product, quantity)}>
            {t("product.addToCart")}
          </button>
        </div>

        <div className="pd-info-block">
          <h4>{t("product.deliveryTitle")}</h4>
          <p>{t("product.deliveryText")}</p>
        </div>
        <div className="pd-info-block">
          <h4>{t("product.storageTitle")}</h4>
          <p>{t("product.storageText")}</p>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;
